import React, { useEffect, useRef, useState } from "react";
import { IoNotifications } from "react-icons/io5";

import valorantlogo from "./../../assets/valorantlogo.png";
import dotalogo from "./../../assets/dota2logo.png";
import lollogo from "./../../assets/lollogo.png";
import tftlogo from "./../../assets/TFTlogo.png";

import {
  Table,
  TableHeader,
  TableColumn,
  TableBody,
  TableRow,
  TableCell,
  Pagination,
} from "@nextui-org/react";
import supabase from "../../config/supabase/supabase";
import { toastError, toastSuccess } from "../../utils/toast";
import { Link } from "react-router-dom";

// Generated by https://quicktype.io

export interface Orders {
  id: number;
  status: string;
  booster: string;
  order_complete_proof: null;
  game_id: number;
  region: string;
  order_id: number;
  price: number;
  created_at: string;
  type_order: string;
  orders_details: OrdersDetail[];
}

export interface OrdersDetail {
  stream: boolean;
  end_rank: string;
  no_stack: boolean;
  priority: boolean;
  win_match: number;
  start_rank: string;
  rank_rating: number;
  end_division: string;
  offline_chat: boolean;
  type_service: string;
  start_division: string;
}

const columns = [
  { name: "Game", uid: "game_id" },
  { name: "ID", uid: "order_id" },
  { name: "Rank", uid: "orders_details" },
  { name: "Region", uid: "region" },
  { name: "Price", uid: "price" },
  //   { name: "Upload", uid: "upload" },
  { name: "Status", uid: "status" },
];

const CompletedOrdersBooster = () => {
  const [data, setData] = useState<Orders[] | []>([]);
  const [files, setFiles] = useState<File | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileClick = () => {
    fileInputRef?.current?.click();
  };

  const handleSubmit = async (order_id: number) => {
    try {
      console.log(files);
      const { data, error } = await supabase
        .from("order")
        .update({ order_complete_proof: files?.name })
        .eq("order_id", order_id)
        .select();

      const { data: uploadData, error: uploadError } = await supabase.storage
        .from("order_completed_proof")
        .upload(`${files?.name as string}`, files as File, {
          cacheControl: "3600",
          upsert: true,
        });

      console.log(data);
      console.log(uploadData);
      console.log(uploadError);
    } catch (error) {
      toastError("Server Error!!");
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      setFiles(files[0]);
    }
  };

  const fetch = async () => {
    try {
      const session = await supabase.auth.getSession();
      let { data: users_details, error: errorUserDetails } = await supabase
        .from("users_details")
        .select("*")
        .eq("id", session.data.session?.user.id)
        .single();

      if (errorUserDetails) return toastError("Error!");

      const boosterGame =
        users_details.role == "Booster Valorant"
          ? 2
          : users_details.role == "Booster League of Legends"
          ? 1
          : users_details.role == "Booster Dota 2"
          ? 4
          : users_details.role == "Booster Teamfight Tactics"
          ? 3
          : null;

      const { data, error } = await supabase
        .from("orders")
        .select(
          "id, status, booster, order_complete_proof , game_id, region ,order_id, price, created_at, type_order, orders_details(start_rank ,start_division,end_rank,end_division,type_service, priority,stream ,rank_rating, no_stack, offline_chat, rank_rating, win_match)"
        )
        .or(`game_id.eq.${boosterGame}`)
        .eq("status", "Order Completed")
        .eq("booster", session.data.session?.user.id)
        .order("created_at", { ascending: false });

      if (error) return toastError("Error!");

      setData(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetch();
  }, []);

  useEffect(() => {
    console.log(files); // Log the files state after it's updated
  }, [files]);

  const renderCell = React.useCallback(
    (orders: Record<string, any>, columnKey: any) => {
      const cellValue = orders[columnKey];

      switch (columnKey) {
        case "game_id":
          return cellValue === 1 ? (
            <div className="w-full h-full  flex justify-start items-center">
              <div className="w-[50px] rounded-full h-[50px] flex justify-center items-center bg-button/10">
                <div className="w-[50px] scale-150 rounded-full h-[50px] flex justify-center items-center">
                  <img src={lollogo} alt="" />
                </div>
              </div>
            </div>
          ) : cellValue === 2 ? (
            <div className="w-full h-full  flex justify-start items-center">
              <div className="w-[50px] rounded-full h-[50px] flex justify-center items-center bg-button/10">
                <div className="w-[50px] scale-120 rounded-full h-[50px] flex justify-center items-center">
                  <img src={valorantlogo} alt="" />
                </div>
              </div>
            </div>
          ) : cellValue === 3 ? (
            <div className="w-full h-full  flex justify-start items-center">
              <div className="w-[50px] rounded-full h-[50px] flex justify-center items-center bg-button/10">
                <div className="w-[50px] scale-150 rounded-full h-[50px] flex justify-center items-center">
                  <img src={tftlogo} alt="" />
                </div>
              </div>
            </div>
          ) : cellValue === 4 ? (
            <div className="w-full h-full  flex justify-start items-center">
              <div className="w-[50px] rounded-full h-[50px] flex justify-center items-center bg-button/10">
                <div className="w-[50px] scale-150 rounded-full h-[50px] flex justify-center items-center">
                  <img src={dotalogo} alt="" />
                </div>
              </div>
            </div>
          ) : (
            ""
          );
        case "order_id":
          return (
            <div className="flex justify-start">
              <p className="text-bold text-sm capitalize text-white">
                {"#" + cellValue.toString().padStart(5, "0")}
              </p>
            </div>
          );
        // case "upload":
        //   return (
        //     <>
        //       <input
        //         type="file"
        //         aria-label="File input"
        //         onChange={(e) => handleFileChange(e)}
        //         ref={fileInputRef}
        //         className="hidden"
        //       />
        //       <button
        //         onClick={() => handleFileClick()}
        //         className=" px-2 py-2  text-[14px] rounded-lg bg-white text-black"
        //         aria-label="Select File"
        //       >
        //         Select File
        //       </button>
        //     </>
        //   );
        case "orders_details":
          return (
            <div className="flex justify-start">
              <p className="text-bold text-sm capitalize text-white">
                {cellValue?.map((value: OrdersDetail, index: number) => {
                  return (
                    <div key={index}>{`${value.start_rank} ${
                      value.start_division
                    } ${
                      value.rank_rating === 0
                        ? "0-25RR"
                        : value.rank_rating === 26
                        ? "26-50RR"
                        : value.rank_rating === 51
                        ? "51-75"
                        : value.rank_rating === 76
                        ? "76-100RR"
                        : ""
                    } - ${value.end_rank} ${value.end_division} | ${
                      orders.type_order
                    } `}</div>
                  );
                })}
              </p>
            </div>
          );
        case "region":
          return (
            <div className="flex justify-start">
              <p className="text-bold text-sm capitalize text-white">
                {cellValue}
              </p>
            </div>
          );
        case "price":
          return (
            <div className="text-white text-start">{`$${cellValue * 0.5}`}</div>
          );
        case "status":
          return (
            <div className="flex justify-start items-center font-bold text-[16px] ">
              <button
                // onClick={() => handleSubmit(orders.order_id)}
                disabled
                className=" px-5  hover:bg-button text-button bg-button/20 transform duration-300 hover:text-white rounded-2xl"
              >
                {orders.status}
              </button>
            </div>
          );
        default:
          return cellValue;
      }
    },
    []
  );

  return (
    <div>
      <div className="w-full table-container  h-[100px] rounded-lg flex justify-end items-center gap-10  px-[20px] mb-[20px]">
        <div className="text-white flex items-center gap-3">
          <h1>Share :</h1>
          <h1 className="font-bold">50%</h1>
        </div>
        <div className="text-white flex items-center gap-3">
          <h1>Balance :</h1>
          <h1 className="font-bold">$124</h1>
        </div>
        <IoNotifications className="text-[24px] cursor-pointer text-white" />
      </div>
      <div className="w-full table-container  h-auto rounded-lg flex justify-end items-center gap-10  px-[20px]">
        <Table
          className=" "
          bottomContentPlacement="outside"
          classNames={{ wrapper: "h-full p-0" }}
          bottomContent={
            data.length === 0 ? (
              <div className="text-white pb-[20px] text-[14px] flex flex-wrap gap-4 items-center justify-center ">
                Sorry, there are no matching records available at the moment.
              </div>
            ) : (
              ""
            )
          }
        >
          <TableHeader columns={columns}>
            {(column) => (
              <TableColumn
                className={`text-white border-secondary py-2 header-container  text-[16px] font-bold  `}
                key={column.uid}
                align={column.uid === "actions" ? "center" : "start"}
              >
                {column.name}
              </TableColumn>
            )}
          </TableHeader>
          <TableBody items={data} className="bg-white">
            {(item) => (
              <TableRow className="font-bold text-[16px]" key={item.id}>
                {(columnKey) => (
                  <TableCell className=" border-secondary font-semibold ">
                    {renderCell(item, columnKey)}
                  </TableCell>
                )}
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

export default CompletedOrdersBooster;
